import React, { Component, Fragment } from 'react';
import Spinner from "../../components/spinner/spinner-component";
import HBIndexChart from "../../components/hb-index-chart/hb-index-chart-component";
import Radio from "../../components/radio/radio-component";



class HBIndexChartComponent extends Component {




  render() {
    const {
      data,
      radio,
      selectedRadio,
      loading,
      changeRadio,
      error
    } = this.props;
    return (
      <div
        style={{
          display: 'flex',
          padding: '10px',
          backgroundColor: 'white',
          borderRadius: '8px',
          position: 'relative',
          minHeight: '150px',
          flexDirection: 'column'
        }}
        className="shadow"
      >
        {
          error
            ?
            <span>{ error }</span>
            :
            data
            ?
            <Fragment>
              <Spinner
                loading={loading}
                absolute
                top="10px"
                left="10px"
              />
              <h2
                style={{
                  textAlign: 'center'
                }}
              >
                HX Index Values
              </h2>
              <div
                style={{
                  width: `${radio.length * 14}%`,
                  alignSelf: 'center',
                  margin: '10px'
                }}
              >
                {
                  radio.length > 1
                  ?
                    <Radio
                      data={radio}
                      selected={selectedRadio}
                      select={changeRadio}
                    />
                    :
                    null
                }

              </div>

              <HBIndexChart
                data={data[selectedRadio]}
              />
            </Fragment>
              :
              null
        }
      </div>
    )
  }
}


export default HBIndexChartComponent;



// WEBPACK FOOTER //
// ./src/modules/hb-index-chart/hb-index-chart-component.js